import * as React from "react";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import { Box, Typography } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import "./InputSearchField.scss";
export default function InputSearchField({
  value = "",
  onChange,
  onClick,
  label,
  maxLength,
  ...props
}) {

  const handleChange = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length > maxLength) return;
    onChange(inputValue);
  };

  return (
    <div>
      <Paper
        component="form"
        variant="outlined"
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "50px",
          border: (props.error !== undefined && props.error !== "") ? "1px solid #FE5050" : "1px solid #D9D9D9",
          borderRadius: "12px",
          background: "transparent",
          opacity: 1,
        }}
      >
        <InputBase
          {...props}
          value={value}
          type={"text"}
          onChange={handleChange}
          sx={{
            ml: 1,
            flex: 1,
            color: "#242424 !important",
            "& input": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
            },
            '& input[type="number"]::-webkit-outer-spin-button,input[type="number"]::-webkit-inner-spin-button': {
              "-webkit-appearance": "none !important",
            },
            '& input[type="number"]': {
              "-moz-appearance": "none !important",
              paddingRight: "20px",
            },
            "&::placeholder": {
              color: "var(--text-primary)",
            },
          }}
          placeholder={label}
          className="input-placeholder"
          inputProps={{
            "aria-label": label,
            maxLength,
            min: "0"
          }}
        />
      </Paper>
      {(props.error !== undefined && props.error !== "") && (
        <Box display={"flex"} alignItems={"center"} pt={0.5}>
          <Box item pr={0.5} mt={0.5}>
            {<ErrorIcon />}
          </Box>
          <Box display="flex" alignItems="center">
            <Typography id="tags-error-message" className="helper-text">{props.error}</Typography>
          </Box>
        </Box>
      )}
    </div>

  );
}
